import { render, staticRenderFns } from "./AccountRequestForm.vue?vue&type=template&id=72f78995&scoped=true&"
import script from "./AccountRequestForm.vue?vue&type=script&lang=js&"
export * from "./AccountRequestForm.vue?vue&type=script&lang=js&"
import style0 from "./AccountRequestForm.vue?vue&type=style&index=0&id=72f78995&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72f78995",
  null
  
)

export default component.exports